import HeaderDash from "../../components/HeaderDash";
import Footer from "../../components/Footer";
import FeaturedDestination from "../../components/FeaturedDestination";
import NeedTour from "../../components/NeedTour";
import FilterDashboard from "../../components/FilterDashboard";
import StaysComponent from "../../components/StaysComponent";

function Stay() {
  return (
    <div>
      <HeaderDash />
      <link rel="stylesheet" href="https://fonts.googleapis.com" />

      <div className="w-[95%] mx-auto">
        <FilterDashboard />

        <p>Explore Stays</p>

        <div className="flex flex-col gap-2">
          <StaysComponent />
          <StaysComponent />
          <StaysComponent />
        </div>

        <FeaturedDestination />

        <NeedTour />
      </div>

      <Footer />
    </div>
  );
}

export default Stay;
